export default class AddActivityController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    months,
    selectedMonth,
    ActivityService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.months = months;
    this.selectedMonth = selectedMonth;
    this.ActivityService = ActivityService;
    this.activity = {};

    if (angular.isDefined(this.selectedMonth)) {
      this.activity.month = this.selectedMonth;
    }
  }

  cancel() {
    this.$mdDialog.cancel();
  }

  save(form) {
    if (form.$invalid) {
      return false;
    }

    const sameMonths = this.activity.month === this.selectedMonth;
    this.ActivityService.add(this.activity, sameMonths)
      .then(() => {
        this.$mdDialog.hide(this.activity.month);
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Pomyślnie dodano zajęcie')
            .position('bottom right')
            .hideDelay(3000)
        );
      }).catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}
